import { useEffect, useRef } from "react";

export const useRestoreScrollPosition = ({
  deps,
  getElement,
}: {
  deps: any[];
  getElement: () => Element | null;
}) => {
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    const element = getElement();
    if (!element) return;
    element.scrollTo({
      top: scrollPositionRef.current,
      behavior: "instant",
    });
  }, deps);

  return {
    setScrollPosition: (scrollPosition: number) => {
      scrollPositionRef.current = scrollPosition;
    },
  };
};
